export default {
    root: function () { return ({
        display: 'inline-block',
    }); },
};
